import {
  CONFIRM_DISPLAY_PRIORITY_MODAL,
  ConfirmDefaultDisplayPriorityModal,
} from 'modules/campaigns/lib/modals/ConfirmDefaultDisplayPriorityModal';
import {
  ALIGN_NODES_MODAL,
  CLEAR_JOURNEY_CONVERSIONS_MODAL,
  CLONE_HAS_UNSAVED_CHANGES_MODAL,
  CLONE_JOURNEY_MODAL,
  CLONE_NODE_MODAL,
  CREATE_LIST_MODAL,
  CREATE_TILESET_MODAL,
  DELETE_DRAFT_MODAL,
  DELETE_NODE_MODAL,
  DESELECT_CHANNELS_MODAL,
  DRAFT_HAS_UNSAVED_CHANGES_MODAL,
  EXIT_RULES_MODAL,
  FIX_STUCK_USERS_MODAL,
  HOLD_UNTIL_REPLY_DELETE_REPLY_MODAL,
  HOLD_UNTIL_REPLY_SWITCH_CAMPAIGN_MODAL,
  HOLD_UNTIL_REPLY_SWITCH_MEDIUM_MODAL,
  JOURNEY_TESTING_MODAL,
  NAVIGATION_TIPS_MODAL,
  NODE_HAS_UNSAVED_CHANGES_MODAL,
  PREVIEW_YES_NO_SPLIT_MODAL,
  PUBLISH_CAMPAIGN_MODAL,
  PUBLISH_JOURNEY_MODAL,
  READ_ONLY_EXIT_RULES_MODAL,
  RESET_TO_PUBLISHED_MODAL,
  RESTORE_AS_DRAFT_CONFIRMATION_MODAL,
  SELECT_TILESET_MODAL,
  SEND_TEST_TRIGGER_MODAL,
  SETTINGS_HAS_UNSAVED_CHANGES_MODAL,
  SETTINGS_SAVE_CHANGES_MODAL,
  SWITCH_PROJECTS_MODAL,
  TOGGLE_JOURNEY_MODAL,
  WORKFLOW_DETAILS_MODAL,
} from '../../constants';
import { AlignNodesModal } from './AlignNodesModal';
import { ClearJourneyConversionsModal } from './ClearJourneyConversionsModal';
import { CloneHasUnsavedChangesModal } from './CloneHasUnsavedChangesModal';
import { CloneJourneyModal } from './CloneJourneyModal';
import { CloneNodeModal } from './CloneNodeModal';
import { CreateListModal } from './CreateListModal';
import { DeleteDraftModal } from './DeleteDraftModal';
import { DeleteNodeModal } from './DeleteNodeModal';
import { DeselectChannelsModal } from './DeselectChannelsModal';
import { DraftHasUnsavedChangesModal } from './DraftHasUnsavedChangesModal';
import { ExitRulesModal } from './ExitRulesModal';
import { FixStuckUsersModal } from './FixStuckUsersModal';
import { HoldUntilReplySwitchMediumModal } from './HoldUntilReplySwitchMediumModal/HoldUntilReplySwitchMediumModal';
import { HoldUntilReplySwitchCampaignModal } from './HoldUntilReplySwitchCampaignModal/HolyUntilReplySwitchCampaignModal';
import { HoldUntilReplyDeleteReplyModal } from './HoldUntilReplyDeleteReplyModal/HoldUntilReplyDeleteReplyModal';
import { JourneyTestingModal } from './JourneyTestingModal/JourneyTestingModal';
import { NavigationTipsModal } from './NavigationTipsModal';
import { NodeHasUnsavedChangesModal } from './NodeHasUnsavedChangesModal';
import PreviewYesNoSplitModal from './PreviewYesNoSplitModal';
import { PublishCampaignModal } from './PublishCampaignModal';
import { PublishJourneyModal } from './PublishJourneyModal';
import { ReadOnlyExitRulesModal } from './ReadOnlyExitRulesModal';
import { ResetToPublishedModal } from './ResetToPublishedModal';
import { RestoreAsDraftConfirmationModal } from './RestoreAsDraftConfirmationModal';
import { SendTestTriggerModal } from './SendTestTriggerModal';
import { SettingsHasUnsavedChangesModal } from './SettingsHasUnsavedChangesModal';
import { SettingsSaveChangesModal } from './SettingsSaveChangesModal';
import { SwitchProjectsModal } from './SwitchProjectsModal';
import { CreateTilesetModal, SelectTilesetModal } from './TilesetsModal';
import { ToggleJourneyModal } from './ToggleJourneyModal';
import { WorkflowDetailsModal } from './WorkflowDetailsModal';

export const WorkflowModals = {
  [ALIGN_NODES_MODAL]: AlignNodesModal,
  [CLONE_HAS_UNSAVED_CHANGES_MODAL]: CloneHasUnsavedChangesModal,
  [CLONE_JOURNEY_MODAL]: CloneJourneyModal,
  [CLONE_NODE_MODAL]: CloneNodeModal,
  [CONFIRM_DISPLAY_PRIORITY_MODAL]: ConfirmDefaultDisplayPriorityModal,
  [CREATE_LIST_MODAL]: CreateListModal,
  [CREATE_TILESET_MODAL]: CreateTilesetModal,
  [DELETE_DRAFT_MODAL]: DeleteDraftModal,
  [DELETE_NODE_MODAL]: DeleteNodeModal,
  [DESELECT_CHANNELS_MODAL]: DeselectChannelsModal,
  [DRAFT_HAS_UNSAVED_CHANGES_MODAL]: DraftHasUnsavedChangesModal,
  [EXIT_RULES_MODAL]: ExitRulesModal,
  [FIX_STUCK_USERS_MODAL]: FixStuckUsersModal,
  [HOLD_UNTIL_REPLY_SWITCH_MEDIUM_MODAL]: HoldUntilReplySwitchMediumModal,
  [HOLD_UNTIL_REPLY_SWITCH_CAMPAIGN_MODAL]: HoldUntilReplySwitchCampaignModal,
  [HOLD_UNTIL_REPLY_DELETE_REPLY_MODAL]: HoldUntilReplyDeleteReplyModal,
  [NAVIGATION_TIPS_MODAL]: NavigationTipsModal,
  [SEND_TEST_TRIGGER_MODAL]: SendTestTriggerModal,
  [WORKFLOW_DETAILS_MODAL]: WorkflowDetailsModal,
  [CLEAR_JOURNEY_CONVERSIONS_MODAL]: ClearJourneyConversionsModal,
  [PUBLISH_CAMPAIGN_MODAL]: PublishCampaignModal,
  [PUBLISH_JOURNEY_MODAL]: PublishJourneyModal,
  [RESET_TO_PUBLISHED_MODAL]: ResetToPublishedModal,
  [NODE_HAS_UNSAVED_CHANGES_MODAL]: NodeHasUnsavedChangesModal,
  [PREVIEW_YES_NO_SPLIT_MODAL]: PreviewYesNoSplitModal,
  [READ_ONLY_EXIT_RULES_MODAL]: ReadOnlyExitRulesModal,
  [RESTORE_AS_DRAFT_CONFIRMATION_MODAL]: RestoreAsDraftConfirmationModal,
  [SELECT_TILESET_MODAL]: SelectTilesetModal,
  [SETTINGS_HAS_UNSAVED_CHANGES_MODAL]: SettingsHasUnsavedChangesModal,
  [SETTINGS_SAVE_CHANGES_MODAL]: SettingsSaveChangesModal,
  [SWITCH_PROJECTS_MODAL]: SwitchProjectsModal,
  [TOGGLE_JOURNEY_MODAL]: ToggleJourneyModal,
  [JOURNEY_TESTING_MODAL]: JourneyTestingModal,
};
